import ReactDOM from 'react-dom';
import App from './containers/App/App';
import * as serviceWorker from './serviceWorker';
import { CampaignContextProvider } from './context/campaign';
import { AuthProvider } from './context/auth';
import { AdminProvider } from './context/admin';
import { RegistrationContextProvider } from './context/registration';
import { ToastProvider } from 'react-toast-notifications';
import { Toaster } from 'react-hot-toast';
import { MyIDProvider } from './context/my-id';
import { GrantsContextProvider } from './context/grants';
import { clarity } from 'react-microsoft-clarity';

if (!window.location.host.includes('localhost')) {
    clarity.init('nrdqw1isyt');
}

ReactDOM.render(
    <ToastProvider placement='top-center' autoDismiss={true}>
        <AdminProvider>
            <AuthProvider>
                <RegistrationContextProvider>
                    <CampaignContextProvider>
                        <MyIDProvider>
                            <GrantsContextProvider>
                                <Toaster
                                    position='bottom-center'
                                    containerStyle={{
                                        bottom: 80,
                                    }}
                                    toastOptions={{
                                        success: {
                                            style: {
                                                background: '#22c55e',
                                                color: 'white',
                                            },
                                        },
                                        error: {
                                            duration: 8000,
                                            style: {
                                                background: '#ef4444',
                                                color: 'white',
                                            },
                                        },
                                        className: 'toast-with-white-links',
                                    }}
                                />
                                <App />
                            </GrantsContextProvider>
                        </MyIDProvider>
                    </CampaignContextProvider>
                </RegistrationContextProvider>
            </AuthProvider>
        </AdminProvider>
    </ToastProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// serviceWorker.register();
